import ReturnPolicySchemajson from '../../seoPlugin/ReturnPolicySchemajson';
export default {
    components:{
        ReturnPolicySchemajson
    },
    data() {
        return {
            cmsData: {},
            siteUrl: this.$serverURL + this.$api.policies.returnolicyURL
        }
    },
    async created(){
        await this.getPageTitles();
        document.title = (this.pageTitles?.returnPageTitle ? this.pageTitles?.returnPageTitle : '');
        await this.getPageCms();
    },
    methods: {
        getPageCms: async function () {
            try {
                let config = {
                    method: "GET",
                    url: this.siteUrl,
                }
                await this.$axios(config).then((response) => { 
                    if(response.data.statusCode == 200){
                        this.cmsData = response.data.data[0];
                    }
                }).catch(error => {
                    console.log(error);
                })
            } catch (error) {
                console.log(error);
            }
        }
    }
}